
// const local = "http://localhost/wordpress";
const serveur = "https://back-end.oxton-digital.com";
export const URL_Back = serveur;
export const URL_Dev = "https://oxton-digital.com"
export const website = 99 ;